import { Route } from "@angular/router";

import { BillingRoutesConstants } from "./billing.routes.constants";

export const billingRoutes: Route = {
  path: BillingRoutesConstants.MAIN,
  children: [
    {
      path: BillingRoutesConstants.SUCCESS,
      loadComponent: () => import("@features/billing/components/success/success.component").then((m) => m.BillingSuccessComponent)
    },
    {
      path: BillingRoutesConstants.CANCEL,
      loadComponent: () => import("@features/billing/components/cancel/cancel.component").then((m) => m.BillingCancelComponent)
    }
  ]
};
